import { useContext } from "react";

import { SmsProviderContext } from "../contexts/SmsProviderContext";
// import { AuthContext } from "../contexts/FirebaseAuthContext";
// import { AuthContext } from "../contexts/Auth0Context";
// import { AuthContext } from "../contexts/CognitoContext";

const useSmsProvider = () => {
  const context = useContext(SmsProviderContext);

  if (!context) throw new Error("SmsProviderContext must be placed within SmsProviderProvider");

  return context;
};

export default useSmsProvider;
